"use client"
import React from "react";
import { Heading, Text } from "@/components/ui/typography";
export default function AboutSection({ heading = "How Much Work Is Setting Up an HK Company Personally?" }: { heading?: string } = {}) {
  const cards = [
    {
      value: "<60",
      description:
        "minutes total founder time across full onboarding",
    },
    {
      value: "14",
      description: <><span>Days To Fully</span> <br/> <span>Operational Structure</span></>,
    },
    {
      value: "1",
      description: <>strategy call is all you <br/>personally attend</>,
    },
    {
      value: "0%",
      description: "offshore tax rate for qualifying structures",
    },
  ];

  return (
    <section className="bg-black w-full py-[60px] px-4 min-[1340px]:px-0 flex flex-col items-center gap-12 overflow-hidden">

      {/* HEADER */}
      <div className="max-w-[600px] flex flex-col gap-6 text-center">
        <Heading as="h2" variant="sectionCentered">
          {heading}
        </Heading>

        <Text variant="muted" muted={60} className="leading-[160%]">
          Very little. Most founders spend less than 60 minutes total across the
          entire onboarding process.
        </Text>
      </div>

      {/* GRID */}
      <div className="max-w-[1200px] mx-auto w-full">
        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {cards.map((card, index) => (
            <div
              key={index}
              className="bg-[#0f1218] border border-white/10 rounded-[16px] p-4 md:p-8 flex flex-col gap-2"
            >
              <div className="text-[44px] font-bold uppercase text-white font-manrope">
                {card.value}
              </div>

              <Text variant="muted" muted={70} size="xs" className="leading-[120%] font-medium">
                {card.description}
              </Text>
            </div>
          ))}
        </div>
      </div>

    </section>
  );
}